import { PRODUCT_PREPAY_CARDS } from '@/constants/products';
import { getProviders } from '@/graphql/queries/shared/institution';
import lang from '@/lang/middleware/products/banking/prepay-cards';

export default async ({ $apolloQuery, store }) => {
  await $apolloQuery(getProviders, { product: PRODUCT_PREPAY_CARDS }).then(providers => {
    store.$i18n.mergeLocaleMessage('en', lang.en);
    const description = store.$i18n.t('providers.description');
    const subtitle = store.$i18n.t('providers.jumbotron.subtitle');
    const title = store.$i18n.t('providers.jumbotron.title');

    store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title, type: 'generic' });
    store.commit('pageContent/setHead', { description, title });
    store.commit('providers/setList', providers);
  });
};
